// Filename - Header.js

import * as React from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

// importing material UI components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import { Link } from "react-router-dom";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";

export default function Header() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <AppBar position="static" className="navwrapper">
      <Toolbar className="navbar">
        <div className="navtitle">
          <Link to="/" className="navmainlink">
            <img src="/logo_small.png" className="navicon" />
            Surfwetter
          </Link>
        </div>
        <IconButton
          size="medium"
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{ mr: 2 }}
          onClick={handleClick}
          className="navlink"
        >
          Seen <ArrowDropDownIcon></ArrowDropDownIcon>
        </IconButton>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          slotProps={{
            list: {
              "aria-labelledby": "basic-button",
            },
          }}
        >
          <Link to="/aegerisee">
            <MenuItem onClick={handleClose}>Ägerisee</MenuItem>
          </Link>
          <Link to="/alpnachersee">
            <MenuItem onClick={handleClose}>Alpnachersee</MenuItem>
          </Link>
          <Link to="/bielersee">
            <MenuItem onClick={handleClose}>Bielersee</MenuItem>
          </Link>
          <Link to="/comersee">
            <MenuItem onClick={handleClose}>Comersee</MenuItem>
          </Link>
          <Link to="/gardasee">
            <MenuItem onClick={handleClose}>Gardasee</MenuItem>
          </Link>
          <Link to="/greifensee">
            <MenuItem onClick={handleClose}>Greifensee</MenuItem>
          </Link>
          <Link to="/hallwilersee">
            <MenuItem onClick={handleClose}>Hallwilersee</MenuItem>
          </Link>
          <Link to="/lacdurosel">
            <MenuItem onClick={handleClose}>Lac du Rosel</MenuItem>
          </Link>
          <Link to="/lagomaggiore">
            <MenuItem onClick={handleClose}>Lago Maggiore</MenuItem>
          </Link>
          <Link to="/murtensee">
            <MenuItem onClick={handleClose}>Murtensee</MenuItem>
          </Link>
          <Link to="/neuenburgersee">
            <MenuItem onClick={handleClose}>Neuenburgersee</MenuItem>
          </Link>
          <Link to="/obersee">
            <MenuItem onClick={handleClose}>Obersee</MenuItem>
          </Link>
          <Link to="/sempachersee">
            <MenuItem onClick={handleClose}>Sempachersee</MenuItem>
          </Link>
          <Link to="/sihlsee">
            <MenuItem onClick={handleClose}>Sihlsee</MenuItem>
          </Link>
          <Link to="/silvaplanersee">
            <MenuItem onClick={handleClose}>Silvaplanersee</MenuItem>
          </Link>
          <Link to="/thunersee">
            <MenuItem onClick={handleClose}>Thunersee</MenuItem>
          </Link>
          <Link to="/untersee">
            <MenuItem onClick={handleClose}>Untersee (Bodensee)</MenuItem>
          </Link>
          <Link to="/urnersee">
            <MenuItem onClick={handleClose}>Urnersee</MenuItem>
          </Link>
          <Link to="/walensee">
            <MenuItem onClick={handleClose}>Walensee</MenuItem>
          </Link>
          <Link to="/weissensee">
            <MenuItem onClick={handleClose}>Weissensee</MenuItem>
          </Link>
          <Link to="/zuerichsee">
            <MenuItem onClick={handleClose}>Zürichsee</MenuItem>
          </Link>
          <Link to="/zugersee">
            <MenuItem onClick={handleClose}>Zugersee</MenuItem>
          </Link>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
